// Modules
// Material-ui
import { styled } from '@mui/material/styles';
import Grid, { type Grid2Props } from '@mui/material/Grid2';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

// Helpers
import { COLORS } from '@/lib/helpers';

// Components
// Common components

export const DropdownListItem = styled(Grid)(({ theme }) => ({
  cursor: 'pointer',
  padding: '0.625rem 1rem',
  backgroundColor: COLORS.WHITE,
  color: COLORS.BLACK,
  '&:hover': {
    backgroundColor: theme.mainColorLight,
    color: theme.mainColor,
  },
})) as typeof Grid;

export const DisabledDropdownListItem = styled(Grid)({
  padding: '0.625rem 1rem',
  backgroundColor: COLORS.WHITE,
  color: COLORS.FORM_INPUT_LABEL,
  cursor: 'not-allowed',
}) as typeof Grid;

export const DropdownListSection = styled(Grid)({
  padding: '0.625rem 1rem',
  fontWeight: 600,
}) as typeof Grid;

export function DropdownListSectionInfo({
  headerText,
  infoText,
  sx,
  ...props
}: {
  headerText: string;
  infoText?: string;
} & Grid2Props) {
  return (
    <Grid {...props} sx={{ p: '1rem', m: '0.5rem 0', backgroundColor: COLORS.GRAY, ...sx }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        {headerText}
      </Typography>
      {infoText ? (
        <p style={{ fontSize: '0.8125rem', lineHeight: '1rem', margin: 0 }}>{infoText}</p>
      ) : null}
    </Grid>
  );
}

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: '0 2rem',
  minWidth: '250px',
  minHeight: '32px !important',
  fontSize: '0.875rem',
  '&:hover': {
    backgroundColor: theme.mainColorLight,
    color: theme.mainColor,
  },
})) as typeof MenuItem;
